// 请勿修改 // 封装统一查看会员信息表格
<template>
  <div>
    <el-table
      border
      height="580px"
      class="table-style"
      :row-class-name="tableRowClassName"
      :header-cell-style="{
        background: '#FCFBF2',
        color: '#6C6839',
        'text-align': 'center',
        fontSize: '14px',
      }"
      :cell-style="{ 'text-align': 'center' }"
      :data="tableData"
      ref="table"
      tooltip-effect="dark"
      :select-on-indeterminate="false"
      @selection-change="handleSelectionChange"
      @select="dialogCheck"
      v-el-table-infinite-scroll="PageTouchTheBottom"
      infinite-scroll-disabled="infiniteScrollDisabledIs"
      v-loading="PagesData.Loading"
    >
      <template v-for="(item, index) in configTable">
        <el-table-column type="selection" v-if="item.prop == 'selection'" :key="index + '-only'" :width="item.width"> </el-table-column>
        <el-table-column v-else-if="item.operation === 'jump'" :prop="item.prop" :label="item.label" :key="index + item.prop" :width="item.width">
          <template slot-scope="scope">
            <el-link type="primary" @click="jumpRecordTransactions(scope.row)">{{ scope.row[item.prop] }}</el-link>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.operation === 'jump_father'" :prop="item.prop" :label="item.label" :key="index + item.prop+'jump_father'" :width="item.width">
          <template slot-scope="scope">
            <el-link type="primary" @click="click_Jump_father(scope.row)">{{ scope.row[item.prop] }}</el-link>
          </template>
        </el-table-column>
        <el-table-column v-else :width="item.width" :prop="item.prop" :label="item.label" :key="index"></el-table-column>
      </template>
      <el-table-column label="操作" v-if="operation" min-width="100">
        <template slot-scope="scope">
          <slot name="operate" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-alert v-if="PagesIsMore" title="没有更多数据了!" type="warning" center :closable="false"> </el-alert>
  </div>
</template>

<script>
export default {
  name: "GiadaTable",
  // 接收父组件传过来了的表格数据
  props: {
    // 客户交易记录数据
    PagesData: {
      type: Object,
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    configTable: {
      type: Array,
      default: () => {
        return [];
      },
    },
    operation: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    PagesIsMore() {
      return this.PagesData.page >= this.PagesData.pages;
    },
    infiniteScrollDisabledIs() {
      return this.PagesData.Loading || this.PagesIsMore;
    },
  },
  methods: {
    click_Jump_father(row){
      this.$emit('lookDetails', row);
    },
    //跳转会员交易记录明细
    jumpRecordTransactions(value) {
      localStorage.setItem("saleID", value.saleID);
      this.$router.push({
        path: "/RecordTransactions",
      });
    },
    PageTouchTheBottom() {
      this.PagesData.Loading = true;
      this.$emit("TouchTheBottom");
    },
    clearSelection() {
      this.$refs.table.clearSelection();
    },
    dialogCheck(selection, row) {
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectioned = row;
        this.$refs.table.toggleRowSelection(row, true);
      }
    },
    handleSelectionChange(value) {
      this.$emit("ReadteSelectChange", value);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
.demonstration {
  font-size: 14rpx;
  font-weight: 400;
  color: #333333;
}
.card-pagination {
  margin-top: 15px;
  height: 50px;
}
// 改变分页背景色
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #d1cda5 !important;
  color: #ffffff !important;
}
// 改变分页字体颜色
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  color: #d1cda5 !important;
}

::v-deep {
  // table隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5;
    color: #ffffff;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5;
  }
}
</style>
